module.exports = __webpack_public_path__ + "static/media/PropertyPhotographywithPole.5f32a85f.svg";